// ── I18N — Dictionnaire FR / NL / EN / DE ──
// Extrait de AureusSocialPro.js pour réduire la taille du monolithe
export const I18N = {
  // ── Navigation principale ──
  'nav.dashboard': { fr:'Tableau de bord', nl:"Dashboard",   },
  'nav.employees': { fr:'Employés', nl:"Werknemers",   },
  'nav.payslip': { fr:'Fiches de paie', nl:"Loonfiches",   },
  'nav.onss': { fr:'ONSS / Déclarations', nl:"RSZ / Aangiften",   },
  'nav.fiscal': { fr:'Fiscal', nl:"Fiscaal",   },
  'nav.salaires': { fr:'Salaires & Calculs', nl:"Lonen & Berekeningen",   },
  'nav.avantages': { fr:'Avantages & Rémunération', nl:"Voordelen & Verloning",   },
  'nav.contrats': { fr:'Contrats & Documents', nl:"Contracten & Documenten",   },
  'nav.rh': { fr:'RH & Personnel', nl:"HR & Personeel",   },
  'nav.social': { fr:'Social & Assurances', nl:"Sociaal & Verzekeringen",   },
  'nav.bienetre': { fr:'Bien-être & Prévention', nl:"Welzijn & Preventie",   },
  'nav.reporting': { fr:'Reporting & Export', nl:"Rapportage & Export",   },
  'nav.legal': { fr:'Juridique & Veille', nl:"Juridisch & Monitoring",   },
  'nav.sprint9': { fr:'Sprint 9 - Modules', nl:'Sprint 9 - Modules',   },
  'nav.portalmanager': { fr:'Portail Clients',nl:'Klantenportaal', },
    'nav.queue': { fr:'File traitement',nl:'Wachtrij', },
    'nav.onboarding': { fr:'Onboarding',nl:'Onboarding', },
    'nav.cloture': { fr:'Clôture Mensuelle',nl:'Maandafsluiting', },
    'nav.notifications': { fr:'Notifications',nl:'Meldingen', },
    'nav.commandcenter': { fr:'Command Center',nl:'Command Center', },
    'nav.autopilot': { fr:'Autopilot',nl:'Autopilot', },
    'nav.smartauto': { fr:'Smart Auto',nl:'Smart Auto', },
    'nav.massengine': { fr:'Mass Engine',nl:'Mass Engine', },
    'nav.automatisation': { fr:'⚡ Automatisation',nl:'⚡ Automatisering', },
    'nav.team': { fr:'Équipe',nl:'Team', },
  'nav.settings': { fr:'Paramètres', nl:"Instellingen",   },
  'nav.aureussuite': { fr:'Aureus Suite', nl:"Aureus Suite",   },
  'nav.back': { fr:'← Tous les dossiers', nl:"← Alle dossiers",   },
  'nav.search': { fr:'🔍 Rechercher un module... (Ctrl+K)', nl:"🔍 Module zoeken... (Ctrl+K)",   },
  'nav.noresult': { fr:'Aucun module trouvé', nl:"Geen module gevonden",   },
  
  // ── Sous-menus ──
  'sub.dimona': { fr:'Dimona', nl:"Dimona",   },
  'sub.dmfa': { fr:'DMFA / DRS', nl:"DmfA / DRS",   },
  'sub.drs': { fr:'DRS / Documents C', nl:"DRS / C-documenten",   },
  'sub.onssapl': { fr:'ONSS-APL (DMFAPPL)', nl:"RSZ-PPL (DmfAPPL)",   },
  'sub.belcotax': { fr:'Belcotax 281.xx', nl:"Belcotax 281.xx",   },
  'sub.precompte': { fr:'Précompte 274', nl:"Bedrijfsvoorheffing 274",   },
  'sub.fiches_ext': { fr:'Fiches spéciales', nl:"Speciale fiches",   },
  'sub.co2': { fr:'Calcul CO2 véhicules', nl:"CO2-berekening voertuigen",   },
  'sub.atn': { fr:'🚗 ATN Véhicules', nl:"🚗 VAA Voertuigen",   },
  'sub.od': { fr:'O.D. Comptables', nl:"Boekhoudkundige OD",   },
  'sub.provisions': { fr:'Provisions', nl:"Voorzieningen",   },
  'sub.cumuls': { fr:'Cumuls annuels', nl:"Jaarlijkse cumulatie",   },
  'sub.netbrut': { fr:'Net → Brut', nl:"Netto → Bruto",   },
  'sub.simcout': { fr:'💰 Simulation coût', nl:"💰 Kostensimulatie",   },
  'sub.saisies': { fr:'Saisies-Cessions', nl:"Beslagen-Overdrachten",   },
  'sub.indexauto': { fr:'Index automatique', nl:"Automatische index",   },
  'sub.horsforfait': { fr:'Heures supplémentaires', nl:"Overuren",   },
  'sub.totalreward': { fr:'🏆 Total Reward', nl:"🏆 Total Reward",   },
  'sub.transport': { fr:'🚇 Transport domicile', nl:"🚇 Woon-werkverkeer",   },
  'sub.treizieme': { fr:'🎄 13ème mois', nl:"🎄 13de maand",   },
  'sub.css': { fr:'💎 Cotisation spéc. SS', nl:"💎 Bijzondere SS",   },
  'sub.bonusemploi': { fr:'🎯 Bonus emploi', nl:"🎯 Werkbonus",   },
  'sub.cheques': { fr:'Chèques-Repas', nl:"Maaltijdcheques",   },
  'sub.ecocmd': { fr:'Éco-chèques', nl:"Ecocheques",   },
  'sub.cafeteria': { fr:'Plan cafétéria', nl:"Cafetariaplan",   },
  'sub.cct90': { fr:'Bonus CCT 90', nl:"Bonus CAO 90",   },
  'sub.warrants': { fr:'Warrants', nl:"Warrants",   },
  'sub.budgetmob': { fr:'Budget mobilité', nl:"Mobiliteitsbudget",   },
  'sub.ecocircul': { fr:'Notes de frais', nl:"Onkostennota\'s",   },
  'sub.contrats2': { fr:'Contrats de travail', nl:"Arbeidsovereenkomsten",   },
  'sub.reglement': { fr:'Règlement de travail', nl:"Arbeidsreglement",   },
  'sub.compteindiv': { fr:'Compte individuel', nl:"Individuele rekening",   },
  'sub.preavis': { fr:'Préavis légal', nl:"Wettelijke opzegging",   },
  'sub.pecsortie': { fr:'Pécule de sortie', nl:"Vertrekvakantiegeld",   },
  'sub.certpme': { fr:'Certificat PME', nl:"KMO-certificaat",   },
  'sub.absences': { fr:'Gestion absences', nl:"Afwezigheidsbeheer",   },
  'sub.onboarding': { fr:'Onboarding', nl:"Onboarding",   },
  'sub.offboarding': { fr:'Offboarding', nl:"Offboarding",   },
  'sub.registre': { fr:'Registre du personnel', nl:"Personeelsregister",   },
  'sub.absenteisme': { fr:'📊 Analyse absentéisme', nl:"📊 Absenteïsme-analyse",   },
  'sub.credittemps': { fr:'Crédit-temps', nl:"Tijdskrediet",   },
  'sub.chomtemp': { fr:'⚠ Chômage temporaire', nl:"⚠ Tijdelijke werkloosheid",   },
  'sub.congeduc': { fr:'🎓 Congé-éducation payé', nl:"🎓 Betaald educatief verlof",   },
  'sub.rcc': { fr:'RCC / Prépension', nl:"SWT / Brugpensioen",   },
  'sub.outplacement': { fr:'Outplacement', nl:"Outplacement",   },
  'sub.pointage': { fr:'⏱ Pointage & Portail', nl:"⏱ Tijdsregistratie & Portaal",   },
  'sub.planform': { fr:'Plan de formation', nl:"Opleidingsplan",   },
  'sub.medtravail': { fr:'Médecine du travail', nl:"Arbeidsgeneeskunde",   },
  'sub.selfservice': { fr:'👤 Portail travailleur', nl:"👤 Werknemersportaal",   },
  'sub.assloi': { fr:'Assurance-Loi AT', nl:"Arbeidsongevallenverzekering",   },
  'sub.assgroupe': { fr:'Assurance Groupe', nl:"Groepsverzekering",   },
  'sub.syndicales': { fr:'Primes syndicales', nl:"Syndicale premies",   },
  'sub.allocfam': { fr:'Alloc. familiales', nl:"Kinderbijslag",   },
  'sub.caissevac': { fr:'Caisse de vacances', nl:"Vakantiekas",   },
  'sub.rentes': { fr:'Rentes', nl:"Renten",   },
  'sub.decava': { fr:'DECAVA', nl:"DECAVA",   },
  'sub.aidesemploi': { fr:"🎯 Aides à l'emploi", nl:"🎯 Tewerkstellingssteun",   },
  'sub.planglobal': { fr:'Plan global prévention', nl:"Globaal preventieplan",   },
  'sub.paa': { fr:'Plan action annuel', nl:"Jaarlijks actieplan",   },
  'sub.risquespsycho': { fr:'Risques psychosociaux', nl:"Psychosociale risico\'s",   },
  'sub.alcool': { fr:'Politique alcool/drogues', nl:"Alcohol-/drugsbeleid",   },
  'sub.elections': { fr:'🗳 Élections sociales', nl:"🗳 Sociale verkiezingen",   },
  'sub.organes': { fr:'CE / CPPT / DS', nl:"OR / CPBW / VA",   },
  'sub.accounting': { fr:'Accounting Output', nl:"Boekhoudkundige Output",   },
  'sub.bilanbnb': { fr:'Bilan Social BNB', nl:"Sociaal Verslag NBB",   },
  'sub.bilan': { fr:'Bilan Social', nl:"Sociaal Verslag",   },
  'sub.statsins': { fr:'Statistiques INS', nl:"INS Statistieken",   },
  'sub.sepa': { fr:'SEPA / Virements', nl:"SEPA / Overschrijvingen",   },
  'sub.peppol': { fr:'🔗 PEPPOL e-Invoicing', nl:"🔗 PEPPOL e-Facturatie",   },
  'sub.envoi': { fr:'Envoi documents', nl:"Documenten versturen",   },
  'sub.exportimport': { fr:'Export / Import', nl:"Export / Import",   },
  'sub.ged': { fr:'📁 GED / Archivage', nl:"📁 DMS / Archivering",   },
  'sub.alertes': { fr:'Alertes légales', nl:"Juridische waarschuwingen",   },
  'sub.secteurs': { fr:'Secteurs spécifiques', nl:"Specifieke sectoren",   },
  'sub.eta': { fr:'Relevés ETA', nl:"ETA-overzichten",   },
  'sub.docsjuridiques': { fr:'📄 Documents Juridiques', nl:"📄 Juridische Documenten",   },
  'sub.config': { fr:'Configuration société', nl:"Bedrijfsconfiguratie",   },
  'sub.fraisgestion': { fr:'💰 Frais de gestion', nl:"💰 Beheerskosten",   },
  'sub.analytics': { fr:'📊 Analytics & KPIs', nl:"📊 Analytics & KPIs",   },
  'sub.filesave': { fr:'💾 Export USB / Fichiers', nl:"💾 USB / Bestanden Export",   },
  
  // ── Headers & Titles ──
  'app.title': { fr:'AUREUS SOCIAL', nl:"AUREUS SOCIAL",   },
  'app.subtitle': { fr:'Logiciel de Paie Pro', nl:"Professionele Loonsoftware",   },
  'app.client': { fr:'Client', nl:"Klant",   },

  // ── Login ──
  'login.title': { fr:'Accès sécurisé', nl:"Beveiligde toegang",   },
  'login.create': { fr:'Créer un code PIN', nl:"PIN-code aanmaken",   },
  'login.enter': { fr:'Entrez votre code PIN', nl:"Voer uw PIN-code in",   },
  'login.btn': { fr:'Se connecter', nl:"Aanmelden",   },
  'login.create_btn': { fr:'Créer', nl:"Aanmaken",   },
  
  // ── Employees ──
  'emp.title': { fr:'Gestion du personnel', nl:"Personeelsbeheer",   },
  'emp.add': { fr:'Ajouter un travailleur', nl:"Werknemer toevoegen",   },
  'emp.firstname': { fr:'Prénom', nl:"Voornaam",   },
  'emp.lastname': { fr:'Nom', nl:"Naam",   },
  'emp.niss': { fr:'NISS', nl:"INSZ",   },
  'emp.birthdate': { fr:'Date de naissance', nl:"Geboortedatum",   },
  'emp.address': { fr:'Adresse', nl:"Adres",   },
  'emp.city': { fr:'Ville', nl:"Stad",   },
  'emp.zip': { fr:'Code postal', nl:"Postcode",   },
  'emp.startdate': { fr:"Date d'entrée", nl:"Datum indiensttreding",   },
  'emp.enddate': { fr:'Date de sortie', nl:"Datum uitdiensttreding",   },
  'emp.function': { fr:'Fonction', nl:"Functie",   },
  'emp.department': { fr:'Département', nl:"Afdeling",   },
  'emp.contract': { fr:'Type contrat', nl:"Contracttype",   },
  'emp.regime': { fr:'Régime', nl:"Regime",   },
  'emp.salary': { fr:'Salaire mensuel brut', nl:"Bruto maandloon",   },
  'emp.iban': { fr:'IBAN', nl:"IBAN",   },
  'emp.civil': { fr:'État civil', nl:"Burgerlijke staat",   },
  'emp.children': { fr:'Enfants à charge', nl:"Kinderen ten laste",   },
  'emp.status_employe': { fr:'Employé', nl:"Bediende",   },
  'emp.status_ouvrier': { fr:'Ouvrier', nl:"Arbeider",   },
  'emp.status_student': { fr:'Étudiant', nl:"Student",   },
  'emp.status_flexi': { fr:'Flexi-job', nl:"Flexi-job",   },
  'emp.sexe': { fr:'Sexe', nl:"Geslacht",   },
  'emp.sexe_m': { fr:'Masculin', nl:"Man",   },
  'emp.sexe_f': { fr:'Féminin', nl:"Vrouw",   },
  'emp.save': { fr:'Enregistrer', nl:"Opslaan",   },
  'emp.delete': { fr:'Supprimer', nl:"Verwijderen",   },
  'emp.active': { fr:'Actif', nl:"Actief",   },
  'emp.inactive': { fr:'Inactif', nl:"Inactief",   },
  
  // ── Contract types ──
  'ct.cdi': { fr:'CDI', nl:"COT",   },
  'ct.cdd': { fr:'CDD', nl:"CBD",   },
  'ct.interim': { fr:'Intérimaire', nl:"Uitzendkracht",   },
  'ct.student': { fr:'Étudiant (650h)', nl:"Student (650u)",   },
  'ct.replacement': { fr:'Remplacement', nl:"Vervanging",   },
  'ct.tpartiel': { fr:'Temps partiel', nl:"Deeltijds",   },
  'ct.full': { fr:'Temps plein', nl:"Voltijds",   },

  // ── Civil status ──
  'civil.single': { fr:'Isolé', nl:"Alleenstaand",   },
  'civil.married1': { fr:'Marié — 1 revenu', nl:"Gehuwd — 1 inkomen",   },
  'civil.married2': { fr:'Marié — 2 revenus', nl:"Gehuwd — 2 inkomens",   },
  'civil.cohabit': { fr:'Cohabitant', nl:"Samenwonend",   },
  'civil.divorced': { fr:'Divorcé', nl:"Gescheiden",   },
  'civil.widow': { fr:'Veuf/Veuve', nl:"Weduwe/Weduwnaar",   },
  
  // ── Payslip ──
  'pay.title': { fr:'Fiche de paie', nl:"Loonfiche",   },
  'pay.period': { fr:'Période', nl:"Periode",   },
  'pay.month': { fr:'Mois', nl:"Maand",   },
  'pay.year': { fr:'Année', nl:"Jaar",   },
  'pay.days': { fr:'Jours prestés', nl:"Gewerkte dagen",   },
  'pay.gross': { fr:'TOTAL BRUT', nl:"TOTAAL BRUTO",   },
  'pay.net': { fr:'NET À PAYER', nl:"NETTO TE BETALEN",   },
  'pay.onss': { fr:'Cotisations ONSS', nl:"RSZ-bijdragen",   },
  'pay.onss_worker': { fr:'ONSS travailleur', nl:"RSZ werknemer",   },
  'pay.onss_employer': { fr:'ONSS employeur', nl:"RSZ werkgever",   },
  'pay.pp': { fr:'Précompte professionnel', nl:"Bedrijfsvoorheffing",   },
  'pay.css': { fr:'Cotisation spéciale séc. soc.', nl:"Bijzondere bijdrage SZ",   },
  'pay.base': { fr:'Salaire de base', nl:"Basisloon",   },
  'pay.overtime': { fr:'Heures sup. (150%)', nl:"Overuren (150%)",   },
  'pay.sunday': { fr:'Heures dimanche (200%)', nl:"Zondaguren (200%)",   },
  'pay.night': { fr:'Heures nuit (125%)', nl:"Nachturen (125%)",   },
  'pay.bonus': { fr:'Prime', nl:"Premie",   },
  'pay.y13': { fr:'13ème mois', nl:"13de maand",   },
  'pay.sick': { fr:'Salaire garanti maladie', nl:"Gewaarborgd loon ziekte",   },
  'pay.advance': { fr:'Acompte', nl:"Voorschot",   },
  'pay.garnish': { fr:'Saisie', nl:"Beslag",   },
  'pay.transport': { fr:'Transport', nl:"Transport",   },
  'pay.expense': { fr:'Frais propres employeur', nl:"Eigen kosten werkgever",   },
  'pay.mv': { fr:'Chèques-repas', nl:"Maaltijdcheques",   },
  'pay.eco': { fr:'Éco-chèques', nl:"Ecocheques",   },
  'pay.employer_cost': { fr:'COÛT EMPLOYEUR', nl:"WERKGEVERSKOST",   },
  'pay.bonus_emploi': { fr:"Bonus à l'emploi", nl:"Werkbonus",   },
  'pay.bonus_fisc': { fr:'Bonus emploi fiscal', nl:"Fiscale werkbonus",   },
  'pay.red_struct': { fr:'Réduction structurelle', nl:"Structurele vermindering",   },
  'pay.print': { fr:'Imprimer', nl:"Afdrukken",   },
  'pay.pdf': { fr:'Télécharger PDF', nl:"PDF downloaden",   },
  'pay.calculate': { fr:'Calculer', nl:"Berekenen",   },
  
  // ── Heures supplémentaires ──
  'hs.overtime': { fr:'H. sup.', nl:"Overuren",   },
  'hs.sunday': { fr:'H. dimanche', nl:"Zondaguren",   },
  'hs.night': { fr:'H. nuit', nl:"Nachturen",   },
  'hs.fiscal': { fr:'H.sup fiscales (180h)', nl:"Overuren fiscaal (180u)",   },
  'hs.volont': { fr:'HS volont. brut=net (h)', nl:"Vrijw. overuren bruto=netto (u)",   },
  'hs.relance': { fr:'HS relance T1 (h)', nl:"Relance-overuren T1 (u)",   },
  
  // ── Settings ──
  'set.company': { fr:'Configuration société', nl:"Bedrijfsconfiguratie",   },
  'set.name': { fr:"Nom de l'entreprise", nl:"Bedrijfsnaam",   },
  'set.vat': { fr:'Numéro TVA', nl:"BTW-nummer",   },
  'set.bce': { fr:'Numéro BCE', nl:"KBO-nummer",   },
  'set.onss_num': { fr:'Numéro ONSS', nl:"RSZ-nummer",   },
  'set.nace': { fr:'Code NACE', nl:"NACE-code",   },
  'set.iban': { fr:'IBAN', nl:"IBAN",   },
  'set.bic': { fr:'BIC', nl:"BIC",   },
  'set.cp': { fr:'Commission paritaire', nl:"Paritair comité",   },
  'set.sec_soc': { fr:'Secrétariat social', nl:"Sociaal secretariaat",   },
  'set.address': { fr:'Adresse', nl:"Adres",   },

  // ── ONSS / Dimona ──
  'onss.dimona_in': { fr:'Dimona IN — Entrée en service', nl:"Dimona IN — Indiensttreding",   },
  'onss.dimona_out': { fr:'Dimona OUT — Sortie de service', nl:"Dimona OUT — Uitdiensttreding",   },
  'onss.worker_type': { fr:'Type de travailleur', nl:"Type werknemer",   },
  'onss.dmfa': { fr:'Déclaration DMFA', nl:"DmfA-aangifte",   },
  'onss.trimester': { fr:'Trimestre', nl:"Kwartaal",   },
  
  // ── SEPA ──
  'sepa.title': { fr:'SEPA / Virements bancaires', nl:"SEPA / Bankoverschrijvingen",   },
  'sepa.salaries': { fr:'Salaires', nl:"Lonen",   },
  'sepa.all': { fr:'TOUT (salaires + ONSS + PP)', nl:"ALLES (lonen + RSZ + BV)",   },
  'sepa.sal_only': { fr:'Salaires uniquement', nl:"Alleen lonen",   },
  'sepa.onss_only': { fr:'ONSS uniquement', nl:"Alleen RSZ",   },
  'sepa.pp_only': { fr:'PP + CSS uniquement', nl:"Alleen BV + BBSZ",   },
  'sepa.download': { fr:'💾 Télécharger .xml', nl:"💾 .xml downloaden",   },
  'sepa.email': { fr:'📧 Ouvrir dans Mail', nl:"📧 Openen in Mail",   },
  'sepa.copy': { fr:'📋 Copier le message', nl:"📋 Bericht kopiëren",   },

  // ── Reporting ──
  'rep.belcotax': { fr:'Belcotax 281.xx', nl:"Belcotax 281.xx",   },
  'rep.bilan': { fr:'Bilan Social', nl:"Sociaal Verslag",   },
  'rep.export': { fr:'Exporter', nl:"Exporteren",   },
  'rep.generate': { fr:'Générer', nl:"Genereren",   },

  // ── Contrats ──
  'ctr.type_cdi': { fr:'Contrat à durée indéterminée', nl:"Arbeidsovereenkomst voor onbepaalde duur",   },
  'ctr.type_cdd': { fr:'Contrat à durée déterminée', nl:"Arbeidsovereenkomst voor bepaalde duur",   },
  'ctr.type_student': { fr:"Convention d'occupation étudiant", nl:"Studentenovereenkomst",   },
  'ctr.type_flexi': { fr:'Contrat flexi-job', nl:"Flexi-job contract",   },
  'ctr.generate': { fr:'Générer le contrat', nl:"Contract genereren",   },
  'ctr.preview': { fr:'Aperçu', nl:"Voorbeeld",   },
  
  // ── Veille légale ──
  'legal.title': { fr:'Veille légale & Calendrier 2026', nl:"Juridische monitoring & Kalender 2026",   },
  'legal.filter': { fr:'Filtrer', nl:"Filteren",   },
  'legal.all': { fr:'Tout', nl:"Alles",   },
  'legal.deadlines': { fr:'📅 Échéances', nl:"📅 Deadlines",   },
  'legal.new2026': { fr:'⚖️ Nouveautés 2026', nl:"⚖️ Nieuw in 2026",   },
  'legal.upcoming': { fr:'🔮 Réformes à venir', nl:"🔮 Komende hervormingen",   },
  'legal.index': { fr:'📈 Indexations', nl:"📈 Indexeringen",   },
  'legal.urgent': { fr:'Urgentes', nl:"Dringend",   },
  'legal.plan': { fr:'À planifier', nl:"Te plannen",   },
  'legal.reminder': { fr:'Rappels', nl:"Herinneringen",   },
  'legal.watch': { fr:'Veille', nl:"Monitoring",   },
  'legal.institutions': { fr:'🏛 Institutions de référence', nl:"🏛 Referentie-instellingen",   },
  'legal.summary': { fr:'Résumé', nl:"Overzicht",   },
  'legal.cal_pp': { fr:'📅 Calendrier PP (FinProf)', nl:"📅 Kalender BV (FinProf)",   },
  'legal.cal_onss': { fr:'📅 Calendrier ONSS / DmfA', nl:"📅 Kalender RSZ / DmfA",   },
  
  // ── Months ──
  'months': {
    fr:['Janvier',"Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],
    nl:['Januari',"Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"],
    
    
  },

  // ── Buttons & General ──
  'btn.save': { fr:'Enregistrer', nl:"Opslaan",   },
  'btn.cancel': { fr:'Annuler', nl:"Annuleren",   },
  'btn.delete': { fr:'Supprimer', nl:"Verwijderen",   },
  'btn.edit': { fr:'Modifier', nl:"Bewerken",   },
  'btn.add': { fr:'Ajouter', nl:"Toevoegen",   },
  'btn.close': { fr:'Fermer', nl:"Sluiten",   },
  'btn.download': { fr:'Télécharger', nl:"Downloaden",   },
  'btn.print': { fr:'Imprimer', nl:"Afdrukken",   },
  'btn.generate': { fr:'Générer', nl:"Genereren",   },
  'btn.validate': { fr:'Valider', nl:"Bevestigen",   },
  'btn.search': { fr:'Rechercher', nl:"Zoeken",   },
  'btn.reset': { fr:'Réinitialiser', nl:"Resetten",   },
  'btn.copy': { fr:'Copier', nl:"Kopiëren",   },
  'btn.export': { fr:'Exporter', nl:"Exporteren",   },
  'btn.import': { fr:'Importer', nl:"Importeren",   },
  'btn.send': { fr:'Envoyer', nl:"Versturen",   },
  'btn.details': { fr:'Détail', nl:"Detail",   },
  'btn.yes': { fr:'Oui', nl:"Ja",   },
  'btn.no': { fr:'Non', nl:"Nee",   },

  // ── Dashboard ──
  'dash.welcome': { fr:'Bienvenue', nl:"Welkom",   },
  'dash.total_emp': { fr:'Travailleurs actifs', nl:"Actieve werknemers",   },
  'dash.mass_sal': { fr:'Masse salariale', nl:"Loonmassa",   },
  'dash.onss_due': { fr:'ONSS dû', nl:"RSZ verschuldigd",   },
  'dash.pp_due': { fr:'PP dû', nl:"BV verschuldigd",   },
  'dash.alerts': { fr:'Alertes', nl:"Waarschuwingen",   },
  'dash.next_deadline': { fr:'Prochaine échéance', nl:"Volgende deadline",   },

  // ── Clients ──
  'cli.title': { fr:'Gestion des dossiers clients', nl:"Beheer klantenbestanden",   },
  'cli.add': { fr:'Nouveau dossier', nl:"Nieuw dossier",   },
  'cli.name': { fr:'Nom du client', nl:"Klantnaam",   },
  'cli.open': { fr:'Ouvrir', nl:"Openen",   },
  'cli.emps': { fr:'travailleurs', nl:"werknemers",   },

  // ── English translations (Sprint 49) ──
  'nav.back': { fr:'Retour aux clients', nl:'Terug naar klanten',   },
  'nav.logout': { fr:'Déconnexion', nl:'Afmelden',   },
  'nav.theme_light': { fr:'Mode jour', nl:'Dagmodus',   },
  'nav.theme_dark': { fr:'Mode nuit', nl:'Nachtmodus',   },
  'nav.search': { fr:'Rechercher...', nl:'Zoeken...',   },
  'nav.cloture': { fr:'Clôture mensuelle', nl:'Maandafsluiting',   },
  'nav.notifications': { fr:'Notifications', nl:'Meldingen',   },
  'nav.commandcenter': { fr:'Centre de commande', nl:'Commandocentrum',   },
  'nav.autopilot': { fr:'Autopilot', nl:'Autopilot',   },
  'nav.massengine': { fr:'Moteur de masse', nl:'Massa-engine',   },
  'nav.queue': { fr:'File de traitement', nl:'Verwerkingswachtrij',   },
  'nav.onboarding': { fr:'Onboarding', nl:'Onboarding',   },
  'nav.portalmanager': { fr:'Gestion Portails', nl:'Portaalbeheer',   },
  'nav.team': { fr:'Équipe', nl:'Team',   },
  'emp.title': { fr:'Gestion des travailleurs', nl:'Werknemersbeheer',   },
  'emp.add': { fr:'Ajouter', nl:'Toevoegen',   },
  'emp.first': { fr:'Prénom', nl:'Voornaam',   },
  'emp.last': { fr:'Nom', nl:'Naam',   },
  'emp.niss': { fr:'NISS', nl:'INSZ',   },
  'emp.brut': { fr:'Brut mensuel', nl:'Bruto maandloon',   },
  'emp.net': { fr:'Net', nl:'Netto',   },
  'emp.status': { fr:'Statut', nl:'Statuut',   },
  'emp.employe': { fr:'Employé', nl:'Bediende',   },
  'emp.ouvrier': { fr:'Ouvrier', nl:'Arbeider',   },
  'pay.brut': { fr:'Salaire brut', nl:'Brutoloon',   },
  'pay.onss': { fr:'ONSS personnelle', nl:'RSZ persoonlijk',   },
  'pay.pp': { fr:'Précompte professionnel', nl:'Bedrijfsvoorheffing',   },
  'pay.net': { fr:'Salaire net', nl:'Nettoloon',   },
  'pay.cout': { fr:'Coût employeur', nl:'Werkgeverskost',   },
  'pay.cheques': { fr:'Chèques-repas', nl:'Maaltijdcheques',   },
  'pay.frais': { fr:'Frais propres', nl:'Eigen kosten',   },
  'pay.bonus': { fr:'Bonus emploi', nl:'Werkbonus',   },
  'btn.save': { fr:'Sauvegarder', nl:'Opslaan',   },
  'btn.cancel': { fr:'Annuler', nl:'Annuleren',   },
  'btn.delete': { fr:'Supprimer', nl:'Verwijderen',   },
  'btn.edit': { fr:'Modifier', nl:'Bewerken',   },
  'btn.export': { fr:'Exporter', nl:'Exporteren',   },
  'btn.download': { fr:'Télécharger', nl:'Downloaden',   },
  'btn.print': { fr:'Imprimer', nl:'Afdrukken',   },
  'btn.generate': { fr:'Générer', nl:'Genereren',   },
  'msg.saved': { fr:'Sauvegarde réussie', nl:'Succesvol opgeslagen',   },
  'msg.error': { fr:'Erreur', nl:'Fout',   },
  'msg.confirm': { fr:'Confirmer', nl:'Bevestigen',   },
  'msg.loading': { fr:'Chargement...', nl:'Laden...',   },
  // ── DocumentGenerator ──
  'docs.title':    { fr:'Générateur de documents', nl:'Documentgenerator',   },
  'docs.subtitle': { fr:'Contrats, attestations et documents sociaux belges', nl:'Contracten, attesten en Belgische sociale documenten',   },
  // ── UI générique ──
  'ui.print':      { fr:'Imprimer', nl:'Afdrukken',   },
  'ui.calculate':  { fr:'Calculer', nl:'Berekenen',   },
  'ui.generate':   { fr:'Générer', nl:'Genereren',   },
  'ui.preview':    { fr:'Aperçu', nl:'Voorbeeld',   },
  'ui.download':   { fr:'Télécharger', nl:'Downloaden',   },
  'ui.send':       { fr:'Envoyer', nl:'Verzenden',   },
  'ui.close':      { fr:'Fermer', nl:'Sluiten',   },
  'ui.search':     { fr:'Rechercher', nl:'Zoeken',   },
  'ui.filter':     { fr:'Filtrer', nl:'Filteren',   },
  'ui.add':        { fr:'Ajouter', nl:'Toevoegen',   },
  'ui.back':       { fr:'Retour', nl:'Terug',   },
  'ui.next':       { fr:'Suivant', nl:'Volgende',   },
  'ui.all':        { fr:'Tout', nl:'Alles',   },
  // ── Navigation ──
  'nav.dashboard': { fr:'Tableau de bord', nl:'Dashboard',   },
  'nav.employees': { fr:'Travailleurs', nl:'Werknemers',   },
  'nav.payroll':   { fr:'Fiches de paie', nl:'Loonfiches',   },
  'nav.documents': { fr:'Documents', nl:'Documenten',   },
  'nav.settings':  { fr:'Paramètres', nl:'Instellingen',   },
  'nav.lois':      { fr:'Lois & Barèmes', nl:'Wetten & Schalen',   },
  'nav.procedures':{ fr:'Procédures RH', nl:'HR-procedures',   },
  // ── Paie ──
  'pay.period':    { fr:'Période', nl:'Periode',   },
  'pay.worker':    { fr:'Travailleur', nl:'Werknemer',   },
  'pay.status':    { fr:'Statut', nl:'Status',   },
  'pay.generate':  { fr:'Générer la fiche', nl:'Loonfiche genereren',   },
  // ── Contrats ──
  'contrat':       { fr:'Contrat', nl:'Contract',   },
  'attestation':   { fr:'Attestation', nl:'Attest',   },
  'sortie':        { fr:'Sortie / Fin contrat', nl:'Uitdiensttreding',   },
  'reglementaire': { fr:'Réglementaire', nl:'Reglementair',   },

  // ── Admin Dashboard ──
  'admin.title':       { fr:'Administration Aureus Social Pro', nl:'Administratie Aureus Social Pro',   },
  'admin.subtitle':    { fr:'Panneau de contrôle administrateur', nl:'Beheerpaneel',   },
  'admin.refresh':     { fr:'Rafraîchir', nl:'Vernieuwen',   },
  'admin.connected':   { fr:'Connecté', nl:'Verbonden',   },
  'admin.loading':     { fr:'Chargement...', nl:'Laden...',   },
  'admin.users_total': { fr:'Utilisateurs total', nl:'Totaal gebruikers',   },
  'admin.active':      { fr:'actifs', nl:'actief',   },
  'admin.clients':     { fr:'Dossiers clients', nl:'Klantendossiers',   },
  'admin.workers':     { fr:'Travailleurs', nl:'Werknemers',   },
  'admin.payslips':    { fr:'Fiches de paie', nl:'Loonfiches',   },
  'admin.this_month':  { fr:'ce mois', nl:'deze maand',   },
  'admin.revenue':     { fr:'Revenu mensuel est.', nl:'Maandelijkse inkomsten',   },
  'admin.search_user': { fr:'Rechercher un utilisateur', nl:'Gebruiker zoeken',   },
  'admin.no_users':    { fr:'Aucun utilisateur inscrit.', nl:'Geen gebruikers gevonden.',   },

  // ── UI générique ──
  'ui.name':           { fr:'Nom', nl:'Naam',   },
  'ui.email':          { fr:'Email', nl:'E-mail',   },
  'ui.role':           { fr:'Rôle', nl:'Rol',   },
  'ui.language':       { fr:'Langue', nl:'Taal',   },
  'ui.lastlogin':      { fr:'Dernière connexion', nl:'Laatste aanmelding',   },
  'ui.registration':   { fr:'Inscription', nl:'Registratie',   },
  'ui.status':         { fr:'Statut', nl:'Status',   },
  'ui.active':         { fr:'Actif', nl:'Actief',   },
  'ui.inactive':       { fr:'Inactif', nl:'Inactief',   },
  // ── Nouveaux modules (Sprint 38+) ──
  'mod.importdonnees': { fr:'Import Données — Transfert ancien SS', nl:'Gegevens importeren — Overdracht vorig sociaal secretariaat',   },
  'mod.importdonnees.sub': { fr:'Importez les données de votre ancien secrétariat social', nl:'Importeer de gegevens van uw vorig sociaal secretariaat',   },
  'mod.soldeconges': { fr:'Solde Congés — Suivi Temps Réel', nl:'Verlofoverzicht — Realtime tracking',   },
  'mod.soldeconges.sub': { fr:'Acquis, pris, restants — par travailleur', nl:'Opgebouwd, opgenomen, resterend — per werknemer',   },
  'mod.signature': { fr:'Signature Électronique', nl:'Elektronische Handtekening',   },
  'mod.signature.sub': { fr:'Contrats signés en ligne — eIDAS conforme', nl:'Contracten online ondertekend — eIDAS conform',   },
  'mod.soumission': { fr:'Assistant Soumission Portails', nl:'Assistent Portaalindiening',   },
  'mod.soumission.sub': { fr:'Guide pas-à-pas Dimona/DmfA/Belcotax', nl:'Stap-voor-stap gids Dimona/DmfA/Belcotax',   },
  'mod.cafeteria': { fr:'Plan Cafétéria — Rémunération Flexible', nl:'Cafetariaplan — Flexibele Verloning',   },
  'mod.cafeteria.sub': { fr:'Optimisation salariale — 4 piliers', nl:'Loonoptimalisatie — 4 pijlers',   },
  'mod.benchmark': { fr:'Benchmark Salarial', nl:'Salariële Benchmark',   },
  'mod.benchmark.sub': { fr:'Comparez vos salaires au marché belge', nl:'Vergelijk uw lonen met de Belgische markt',   },
  'mod.virements': { fr:'Virements Automatiques', nl:'Automatische Overschrijvingen',   },
  'mod.virements.sub': { fr:'Salaires nets + ONSS + PP', nl:'Nettolonen + RSZ + BV',   },
  'mod.support': { fr:'Support Client', nl:'Klantenondersteuning',   },
  'mod.support.sub': { fr:'Équipe dédiée + tickets + rappel téléphonique + Agent IA', nl:'Toegewijd team + tickets + terugbelservice + AI Agent',   },
  'mod.facturation': { fr:'Facturation Fiches de Paie', nl:'Facturatie Loonfiches',   },
  'mod.facturation.sub': { fr:'Suivi des paiements clients', nl:'Opvolging klantenbetalingen',   },
  // ── Labels communs nouveaux modules ──
  'btn.generate': { fr:'Générer', nl:'Genereren',   },
  'btn.download': { fr:'Télécharger', nl:'Downloaden',   },
  'btn.print': { fr:'Imprimer', nl:'Afdrukken',   },
  'btn.save_pdf': { fr:'Enregistrer PDF', nl:'Opslaan als PDF',   },
  'btn.copy_email': { fr:'Copier pour email', nl:'Kopiëren voor e-mail',   },
  'btn.back': { fr:'Retour', nl:'Terug',   },
  'btn.close': { fr:'Fermer', nl:'Sluiten',   },
  'btn.approve': { fr:'Approuver', nl:'Goedkeuren',   },
  'btn.import': { fr:'Importer', nl:'Importeren',   },
  'btn.new_import': { fr:'Nouvel import', nl:'Nieuwe import',   },
  'btn.mark_paid': { fr:'Marquer payé', nl:'Markeer als betaald',   },
  'btn.select': { fr:'Sélectionner', nl:'Selecteren',   },
  'lbl.source': { fr:'Source', nl:'Bron',   },
  'lbl.data_type': { fr:'Type de données', nl:'Gegevenstype',   },
  'lbl.mapping': { fr:'Mapping des colonnes', nl:'Kolommapping',   },
  'lbl.result': { fr:'Résultat', nl:'Resultaat',   },
  'lbl.imported': { fr:'Importés', nl:'Geïmporteerd',   },
  'lbl.skipped': { fr:'Ignorés', nl:'Overgeslagen',   },
  'lbl.total': { fr:'Total', nl:'Totaal',   },
  'lbl.worker': { fr:'Travailleur', nl:'Werknemer',   },
  'lbl.client': { fr:'Client', nl:'Klant',   },
  'lbl.period': { fr:'Période', nl:'Periode',   },
  'lbl.gross': { fr:'Brut', nl:'Bruto',   },
  'lbl.net': { fr:'Net', nl:'Netto',   },
  'lbl.status': { fr:'Statut', nl:'Status',   },
  'lbl.action': { fr:'Action', nl:'Actie',   },
  'lbl.date': { fr:'Date', nl:'Datum',   },
  'lbl.all': { fr:'Tous', nl:'Alle',   },
  'lbl.paid': { fr:'Payé', nl:'Betaald',   },
  'lbl.unpaid': { fr:'Impayé', nl:'Onbetaald',   },
  'lbl.leave_legal': { fr:'Congés légaux', nl:'Wettelijk verlof',   },
  'lbl.leave_extra': { fr:'Congés extra-légaux', nl:'Extrawettelijk verlof',   },
  'lbl.leave_seniority': { fr:'Congés ancienneté', nl:'Anciënniteitsverlof',   },
  'lbl.leave_recovery': { fr:'Jours récupération', nl:'Recuperatiedagen',   },
  'lbl.sick_days': { fr:'Jours maladie', nl:'Ziektedagen',   },
  'lbl.remaining': { fr:'Restant', nl:'Resterend',   },
  'lbl.taken': { fr:'Pris', nl:'Opgenomen',   },
  'lbl.pending': { fr:'En attente', nl:'In afwachting',   },
  'lbl.acquired': { fr:'Acquis', nl:'Opgebouwd',   },
  'lbl.active_client': { fr:'Client actif', nl:'Actieve klant',   },
  'lbl.docs_in_name_of': { fr:'Documents au nom de', nl:'Documenten op naam van',   },
  'lbl.internal': { fr:'(interne)', nl:'(intern)',   },
  'lbl.my_manager': { fr:'Mon gestionnaire', nl:'Mijn beheerder',   },
  'lbl.new_ticket': { fr:'+ Nouveau ticket', nl:'+ Nieuw ticket',   },
  'lbl.callback': { fr:'Rappel téléphonique', nl:'Terugbelservice',   },
  'lbl.my_tickets': { fr:'Mes tickets', nl:'Mijn tickets',   },
  'lbl.sla': { fr:'SLA & Engagements', nl:'SLA & Afspraken',   },
  'lbl.agent_ia': { fr:'Agent IA juridique', nl:'Juridische AI Agent',   },
  'lbl.open_ticket': { fr:'Ouvrir un ticket', nl:'Ticket openen',   },
  'lbl.request_callback': { fr:'Demander un rappel', nl:'Terugbelverzoek',   },
  'lbl.support_channels': { fr:'Canaux de support', nl:'Ondersteuningskanalen',   },
  'lbl.mobility': { fr:'Mobilité', nl:'Mobiliteit',   },
  'lbl.technology': { fr:'Technologie', nl:'Technologie',   },
  'lbl.protection': { fr:'Protection', nl:'Bescherming',   },
  'lbl.wellbeing': { fr:'Bien-être', nl:'Welzijn',   },
  'lbl.budget_per_worker': { fr:'Budget annuel par travailleur', nl:'Jaarlijks budget per werknemer',   },
  'lbl.simulator': { fr:'Simulateur', nl:'Simulator',   },
  'lbl.by_employee': { fr:'Par employé', nl:'Per werknemer',   },
  'lbl.below_market': { fr:'Sous le marché', nl:'Onder de markt',   },
  'lbl.in_market': { fr:'Dans le marché', nl:'In de markt',   },
  'lbl.above_market': { fr:'Au-dessus', nl:'Boven de markt',   },
};
